import React, { Component } from 'react';
import MainRoutes from '../config/route-main';

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { setToken } from './App.actions'

import './App.css';

class App extends Component {

  componentWillMount() {
    const token = sessionStorage.getItem('token')
    if (token) {
      this.props.setToken(token)
    }
  }

  render() {
    return (
      <div className="App">
        <MainRoutes />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  state: state
});

const mapDispatchToProps = dispatch => bindActionCreators({ setToken }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App/App.js